module.exports = __webpack_public_path__ + "static/page-banner-mobile-development-ecb4265aeb7b1e44389534a02344a8ab.png";